var MdCheckboxes = function () {

  var hideCheckboxes = function () {
    //$('.md-checkbox').addClass('md-checkbox-invisible')
    $('.md-checkbox-all').addClass('md-checkbox-invisible');
    $('.md-checkbox-action-btn').addClass('disabled');
    $('.md-checkbox-sums-table').addClass('invisible');
  }

  var showCheckboxes = function () {
    $('.md-checkbox').removeClass('md-checkbox-invisible');
    $('.md-checkbox-all').removeClass('md-checkbox-invisible');
    $('.md-checkbox-action-btn').removeClass('disabled');
    $('.md-checkbox-sums-table').removeClass('invisible')
  }

  var fillIdArrayWithCheckeds = function() {
    var object_ids = [];

    $('.md-checkbox').each(function () {
      if (this.checked) {
        object_ids.push($(this).val());
      }
    });
    return object_ids;
  }

  var calculateTotals = function() {
    if ($('.md-checkbox-all').data('parent-type') == 'Logistics::Loading') {
      calculateLoadingTotals();
    }
  }

  var calculateLoadingTotals = function() {
    var totalWeight = 0;
    var totalLade   = 0;
    var totalVolume = 0;
    var totalPrice  = 0;
    $('.md-checkbox').each(function () {
      if (this.checked) {
        totalWeight += numericValue($(this).data('brut-wg'));
        totalLade   += numericValue($(this).data('ladameter'));
        totalVolume += numericValue($(this).data('volume'));
        totalPrice  += numericValue($(this).data('freight-price'));
      }
    });
    $('#total-brut-wg').text(totalWeight);
    $('#total-ladameter').text(totalLade);
    $('#total-volume').text(totalVolume);
    $('#total-freight-price').text(totalPrice);
  }

  var numericValue = function(iVal) {
    if (!isNaN(iVal) && iVal.length != 0) {
      return parseFloat(iVal);
    } else {
      return 0;
    }
  }

  var openNewLedger = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/ledgers/new?layout=metronic",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type
      });
    }
  }

  var deleteInvoiceLedgers = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/ledgers/destroy_list",
        dataType: "script",
        data: "doc_type=Financor::Invoice&object_ids=" + selected_objects
      });
    }
  }

  var deleteDocuments = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "DELETE",
        url: "/findocs/destroy",
        dataType: "script",
        data: "object_ids=" + selected_objects
      });
    }
  }

  var openPatronSelection = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/partners",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type
      });
    }
  }

  var checkStatusOfEinvoices = function(){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/einvoices/check_status",
        dataType: "script",
        data: "object_ids=" + selected_objects
      });
    }
  }

  var sendSelectedInvoices = function(){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/invoices/send_einvoices",
        dataType: "script",
        data: "object_ids=" + selected_objects
      });
    }
  }

  var bulkChanges = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/estimated_payments/bulk_changes",
        dataType: "script",
        data: "object_ids=" + selected_objects
      });
    }
  }

  var changeStatus = function(type){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/estimated_payments/change_status",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type + "&status=" + type
      });
    }
  }

  var paidEstimateds = function(type){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects     = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0){
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    }else{
      $.ajax({
        type: "GET",
        url: "/estimated_payments/paid_estimateds",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type + "&status=" + type
      });
    }
  }


  var printSelectedPayrolls = function(search_id){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/payrolls/print",
        dataType: "html",
        data: "object_ids=" + selected_objects,
        success: function (url) {
          console.log("windowww");
          window.open(this.url);
        }
      });
    }
  }



  var setPayrollPaymentTypes = function(payment_type) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/payrolls/set_payment_type",
        dataType: "script",
        data: "payment_type=" + payment_type + "&object_ids=" + selected_objects + "&object_type=" + selected_object_type
      });
    }
  }



  var downloadBulkPayrolls = function(type){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      window.open("/people/download.zip?object_ids=" + selected_objects);
    }
  }

  var downloadBulkInvoices = function(type){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      window.open("/invoices/download.zip?object_ids=" + selected_objects);
    }
  }

  var downloadInvoiceTempdocs = function(invoice_id, template_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/invoices/" + invoice_id + "/preview",
        dataType: "html",
        data: "invoice_ids=" + selected_objects + "&template_id=" + template_id,
        success: function (url) {
          window.open(this.url);
        }
      });
    }
  }

  var cloneSelectedManifesto = function(){
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/manifestos/clone_manifest",
        dataType: "script",
        data: "object_ids=" + selected_objects
      });
    }
  }
  
  var addTransfinsLoadings = function(invoice_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/transfins/add_loadings",
        dataType: "script",
        data: "invoice_id=" + invoice_id + "&object_ids=" + selected_objects + "&object_type=" + selected_object_type
      });
    }
  }

  var addExpenseFormForSelectedItems = function(scope) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/expense_forms/add_expense_form",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&scope=" + scope,
        success: function (url) {
          window.open(this.url);
        }
      });
    }
  }

  var confirmSelectedInvoices = function(type) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/invoices/set_approved",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type + "&approval_type=" + type
      });
    }
  }

  var confirmSelectedFindocs = function(type) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/findocs/set_approved",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type + "&approval_type=" + type
      });
    }
  }

  var transferSelectedBankTransfers = function(type) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/bank_transfers/set_transfered",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&object_type=" + selected_object_type + "&approval_type=" + type
      });
    }
  }

  var planLoadings = function(index_type, action, operation_id, trans_method, vessel_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (trans_method === '' || trans_method === null) {
      $('.md-checkbox').each(function () {
      if (this.checked) {
        trans_method = $(this).data('trans-method');
        return false;
      }
    });
    }
    $.ajax({
      type: "GET",
      url: "/positions/new",
      dataType: "script",
      data: "loading_ids=" + selected_objects + "&operation_id=" + operation_id + "&trans_method=" + trans_method + "&vessel_id=" + vessel_id +  "&index_type=" + index_type + "&form_type=planner"
    });
  }

  var openNewEstimate = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/involines/new",
        dataType: "script",
        data: "loading_ids=" + selected_objects
      });
    }
  }

  var sendDocuments = function(position_id, template_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/positions/" + position_id + "/preview",
        dataType: "script",
        data: "loading_ids=" + selected_objects + "&template_id=" + template_id
      });
      Site.showMessage('Dökümanlar gönderiliyor, bu işlem birkaç dk. sürebilir.','warning');
    }
  }

  var updateLoadingsCMRStatus = function(position_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/positions/" + position_id + "/edit",
        dataType: "script",
        data: "loading_ids=" + selected_objects + "&form_type=cmr"
      });
    }
  }

  var updatePositionandLoadings = function(position_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/positions/" + position_id + "/edit",
        dataType: "script",
        data: "loading_ids=" + selected_objects + "&form_type=border"
      });
    }
  }
  
  var clonePositionandLoadings = function(position_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/positions/" + position_id + "/clone",
        dataType: "script",
        data: "ref_loading_ids=" + selected_objects + "&ref_position_id=" + position_id
      });
    }
  }

  var assigneeTodos = function() {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/helpdesk/todos/assignee",
        dataType: "script",
        data: "object_ids=" + selected_objects

      });
    }
  }

  var assigneeManifestos = function(position_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/manifestos/new",
        dataType: "html",
        data: "object_ids=" + selected_objects,
        data: "position_id=" + position_id + "&loading_ids=" + selected_objects,
        success: function (url) {
          window.open(this.url);
        }
      });
    }
  }

  var addLoadingsToPosition = function(position_id) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "POST",
        url: "/planners",
        dataType: "script",
        data: {
          planner: {
            user_id: modaltrans.current_user_id,
            position_id: position_id,
            transport_ids: selected_objects.join(',')
          }
        }
      });
    }
  }

  var addExpenseFormForSelectedItems = function(scope) {
    selected_object_type = $('.md-checkbox-all').data('parent-type');
    selected_objects = fillIdArrayWithCheckeds();
    if (selected_objects.length === 0) {
      Site.showMessage('Lütfen en az bir adet kayıt seçiniz','warning');
    } else {
      $.ajax({
        type: "GET",
        url: "/expense_forms/add_expense_form",
        dataType: "script",
        data: "object_ids=" + selected_objects + "&scope=" + scope,
        success: function (url) {
          window.open(this.url);
        }
      });
    }
  }

  var addPositionToLoading = function(position_id, loading_id) {
    if (loading_id && loading_id) {
      $.ajax({
        type: "POST",
        url: "/planners",
        dataType: "script",
        data: {
          planner: {
            user_id: modaltrans.current_user_id,
            position_id: position_id,
            loading_id: loading_id
          }
        }
      });
    } else {
      Site.showMessage('A problem has occurred please get help from the modaltrans team.','warning');
    }
  }


  var handleMdCheckboxes = function() {
    //select all checkbox clicked
    $(document).on('click', '.md-checkbox-all', function(event) {
      if (this.checked) {
        showCheckboxes();
        $('.md-checkbox').prop('checked', true);
      } else {
        hideCheckboxes();
        $('.md-checkbox').prop('checked', false);
      }
      calculateTotals();
    });

    $(document).on('click', '.md-group-checkbox-all, .md-group-checkbox', function(event) {
      var groupId = $(this).attr("group-id");
      var checked = false

      if (this.checked) {
        $('.md-checkbox-' + groupId).prop('checked', true);
      } else {
        $('.md-checkbox-' + groupId).prop('checked', false);
      }

      $('.md-group-checkbox').each(function() {
        if (this.checked) {
          checked = true
        }
      });

      if (checked === true ) {
        $('.md-checkbox-action-btn').removeClass('disabled');
      } else {
        $('.md-checkbox-action-btn').addClass('disabled');
      }

    });

    //only one checkbox is clicked
    $(document).on('click', '.md-checkbox', function(event) {
      if (this.checked) {
        showCheckboxes();
      } else {
        $('.md-checkbox-all').prop('checked', false);
        if (!$('.md-checkbox').is(':checked')) {
          hideCheckboxes();
        }
      }
      calculateTotals();
    });
  }

  return {
    init: function () {
      handleMdCheckboxes();
    },
    ledgerSelectedObjects: function() {
      openNewLedger();
    },
    deleteInvoiceLedgerSelectedObjects: function() {
      deleteInvoiceLedgers();
    },
    sendSelectedInvoices: function() {
      sendSelectedInvoices();
    },
    deleteSelectedDocuments: function(){
      deleteDocuments();
    },
    addExpenseFormForSelectedItems: function(scope) {
      addExpenseFormForSelectedItems(scope);
    },
    copySelectedInvoices: function() {
      openPatronSelection();
    },
    checkStatusOfEinvoices: function() {
      checkStatusOfEinvoices();
    },
    bulkChangesForEstimateds: function() {
      bulkChanges();
    },
    changeStatusToPayableEstimateds: function(type){
      changeStatus(type);
    },
    changeStatusToPaidEstimateds: function(type){
      paidEstimateds(type);
    },
    printSelectedPayrolls: function(search_id) {
      printSelectedPayrolls(search_id);
    },
    downloadBulkPayrolls: function(type) {
      downloadBulkPayrolls(type);
    },
    downloadBulkInvoices: function(type) {
      downloadBulkInvoices(type);
    },
    downloadInvoiceTempdocs: function(invoice_id, template_id) {
      downloadInvoiceTempdocs(invoice_id, template_id);
    },
    setPayrollPaymentTypes: function(payment_type) {
      setPayrollPaymentTypes(payment_type);
    },
    confirmSelectedObjects: function(type) {
      confirmSelectedInvoices(type);
    },
    confirmSelectedDocuments: function(type) {
      confirmSelectedFindocs(type);
    },
    transferSelectedTransactions: function(type) {
      transferSelectedBankTransfers(type);
    },
    planSelectedLoadings: function(index_type, action, operation_id, trans_method, vessel_id) {
      planLoadings(index_type, action, operation_id, trans_method, vessel_id);
    },
    addEstimateToSelectedItems: function() {
      openNewEstimate();
    },
    sendDocumentsForSelectedItems: function(position_id, template_id) {
      sendDocuments(position_id, template_id);
    },
    updateBorderDateToSelectedItems: function(position_id){
      updatePositionandLoadings(position_id);
    },
    updateCMRStatusToSelectedItems: function(position_id){
      updateLoadingsCMRStatus(position_id);
    },
    clonePositionWithSelectedItems: function(position_id){
      clonePositionandLoadings(position_id);
    },
    selectedTodos: function() {
      assigneeTodos();
    },
    selectedManifestos: function(position_id) {
      assigneeManifestos(position_id);
    },
    addSelectedLoadings: function(invoice_id) {
      addTransfinsLoadings(invoice_id);
    },
    cloneSelectedManifesto: function() {
      cloneSelectedManifesto();
    },
    addSelectedLoadingsToPosition: function(position_id) {
      addLoadingsToPosition(position_id);
    },
    addExpenseFormForSelectedItems: function(scope) {
      addExpenseFormForSelectedItems(scope);
     },
    addSelectedPositionToLoading: function(position_id, loading_id) {
      addPositionToLoading(position_id, loading_id)
    }
  };

}();

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = MdCheckboxes;
}
